import { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { MenuManager } from "../MenuManager"
import { Header } from "../../common/header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IBrockmanBankDto } from "../../../types/brockman/IBrockmanBankDto"
import { IB64File } from "../../../types/IB64File"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useNavigate, useParams } from "react-router-dom"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { CommonFileList } from "../../common/element/fields/CommonFileList"
import { IBrockmanDetailDto } from "../../../types/brockman/IBrockmanDetailDto"
import { CONFIG } from "../../../CONFIG"
import { download } from "../../common/CommonHelper"
import { IMG } from "../../common/CONST"
import { DASHBOARD_ROUTE } from "@/routes"

export const BrockmanManager = () => {
  const navigate = useNavigate()
  const params = useParams()

  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [confirmMessage, setConfirmMessage] = useState<IModalMessage>()
  const [brockmanBank, setBrockmanBank] = useState<IBrockmanBankDto>()
  const [brockmanDetail, setBrockmanDetail] = useState<IBrockmanDetailDto>()
  const [files, setFiles] = useState<IB64File[]>([])

  // const handleInnChange = (inn: IInnSuggestion | undefined) => {
  //   if (inn && inn.suggestions.length > 0) {
  //     setBrockmanBank({ ...brockmanBank, inn: inn.suggestions[0].data.inn })
  //     setBrockmanDetail({
  //       ...brockmanDetail,
  //       name: inn.suggestions[0].value,
  //       beneficiaryAddress: inn.suggestions[0].data.address.unrestricted_value
  //     })
  //   }
  // }

  const getPreview = (): string | undefined => {
    if (brockmanBank && brockmanBank.avatar?.b64 && brockmanBank.avatar.name) {
      const ext = brockmanBank.avatar.name.split(".").pop()?.toLowerCase()
      if (ext === "jpg" || ext === "jpeg") {
        return "data:image/jpeg;base64," + brockmanBank.avatar.b64
      } else if (ext === "png") {
        return "data:image/png;base64," + brockmanBank.avatar.b64
      } else if (ext === "svg") {
        return "data:image/svg+xml;base64," + brockmanBank.avatar.b64
      } else {
        return undefined
      }
    } else if (brockmanBank && brockmanBank.avatarPath) {
      return `${CONFIG.STORAGE_URL}/${brockmanBank.avatarPath}`
    } else {
      return undefined
    }
  }

  useEffect(() => {
    if (params.id && params.id !== "new") {
      TrinityAPI.getBrockmanBank(params.id, response => {
        if (response.status === 200) {
          setBrockmanBank(response.data)
          setBrockmanDetail(response.data.brockmanDetail)
        } else {
          setModalMessage({ title: "Ошибка!", text: "Ошибка получения банка: " + response.data.message })
        }
      })
    }
  }, [])

  useEffect(() => {
    const newFiles = new Array<IB64File>()
    if (brockmanBank?.avatar) {
      newFiles.push(brockmanBank.avatar)
    }
    if (brockmanBank?.additionalAgreement) {
      newFiles.push(brockmanBank.additionalAgreement)
    }
    setFiles(newFiles)
  }, [brockmanBank])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <ModalConfirm message={confirmMessage} setMessage={() => setConfirmMessage(undefined)} />
      <MenuManager active={"dashboard"} />
      <section className="new-contragent">
        <Header />
        <div className="container">
          <h3 className="ui-heading">{brockmanBank?.name && brockmanBank.id ? brockmanBank.name : "Новый банк"}</h3>
          <div className="container-pop-up">
            <div className="form-left">
              <div className="form-block-popup">
                <h4 className="heading-chapter">Информация о банке</h4>
                <fieldset>
                  <legend>БИК</legend>
                  <p className="text-form">{brockmanBank?.bic}</p>
                </fieldset>
                <fieldset>
                  <legend>Название банка</legend>
                  <p className="text-form">{brockmanBank?.name}</p>
                </fieldset>
                <fieldset>
                  <legend>Краткое название банка</legend>
                  <p className="text-form">{brockmanBank?.shortName}</p>
                </fieldset>
                <fieldset>
                  <legend>Адрес банка</legend>
                  <p className="text-form">{brockmanBank?.address}</p>
                </fieldset>
              </div>

              <div className="form-block-popup">
                <h4 className="heading-chapter">Информация о получателе</h4>
                <fieldset>
                  <legend>ИНН получателя</legend>
                  <p className="text-form">{brockmanBank?.inn}</p>
                </fieldset>
                <fieldset>
                  <legend>Расчетный счет получателя</legend>
                  <p className="text-form">{brockmanBank?.account}</p>
                </fieldset>
                <fieldset>
                  <legend>Имя получателя (Received From в счете)</legend>
                  <p className="text-form">{brockmanDetail?.name}</p>
                </fieldset>
                <fieldset>
                  <legend>Краткое имя получателя</legend>
                  <p className="text-form">{brockmanDetail?.shortName || "-"}</p>
                </fieldset>
                <fieldset>
                  <legend>Адрес получателя (Beneficiary Address в счете)</legend>
                  <p className="text-form">{brockmanDetail?.beneficiaryAddress}</p>
                </fieldset>
              </div>
            </div>
            <div className="right-form">
              <div className="form-block-popup">
                <h4 className="heading-chapter">О банке</h4>
                {(brockmanBank?.avatar?.b64 || brockmanBank?.avatarPath) && (
                  <ul className="bank-deals-flex" style={{ pointerEvents: "none" }}>
                    <li className="deals-bank-item">
                      <img src={getPreview()} className="deals-bank-img" alt="preview-bank" />
                    </li>
                  </ul>
                )}

                <div className="flex-row-10">
                  {brockmanBank?.id && (
                    <fieldset>
                      <legend>Загруженный бланк</legend>
                      <label className="button-file-dl">
                        <input
                          type="button"
                          multiple={false}
                          className="hidden-object"
                          placeholder="Скачать"
                          onClick={() => download(brockmanBank.id, "BLANK_AGREEMENT")}
                        />
                        <img src={IMG.download_bank} alt="" className="load-file-new" /> Скачать
                      </label>
                    </fieldset>
                  )}
                </div>
                <CommonFileList files={files} />
              </div>
            </div>
            <div className="flex-row-24">
              <button className="btn grey-btn" onClick={() => navigate(DASHBOARD_ROUTE)}>
                На главную
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
